import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import profileService from "services/profile/profile.service";
import * as utility from "utilities/utils";


export const getProfile = createAsyncThunk(
    "profile/getProfile",
    async (_, { rejectWithValue }) => {
        try {
            return await profileService.getProfile();
        } catch (err) {
            return rejectWithValue(utility.getErrorResponse(err));
        }
    }
);

const profileSlice = createSlice({
    name: "profile",
    initialState: { data: {}, loading: false, error: null },
    reducers: {
        setProfile(state, action) {
            state.data = { ...action.payload };
            state.loading = false;
            state.error = null;
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(getProfile.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(getProfile.fulfilled, (state, action) => {
                state.loading = false;
                state.data = action.payload.data;
            })
            .addCase(getProfile.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            });

    }
});

export const { setProfile } = profileSlice.actions;
export default profileSlice.reducer;
